import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import {
  UniButtonsModule,
  UniFormFieldModule,
  UniStepperModule,
  UniInputModule,
  UniSelectModule,
  UniSummaryModule,
  UniTableModule,
} from "@universal-ui";

import { FormSharedModule } from "@shared/FormShared/form-shared.module";
import { SharedModule } from "@shared/Modules/shared.module";
import { NgxFileDropModule } from "ngx-file-drop";

import { RequestDetailsComponent } from "./Components/RequestDetails/request-details.component";
import { FiduciaryRequestsTableComponent } from "./Components/ResultsTable/fiduciary-requests-table.component";
import { FiduciarySearchFormComponent } from "./Components/SearchForm/fiduciary-search-form.component";
import { FiduciarySearchRoutingModule } from "./fiduciary-request-search-routing.module";
import { FiduciaryRequestSearchComponent } from "./fiduciary-request-search.component";
import { RequestDetailsDocumentsComponent } from './Components/request-details-documents/request-details-documents.component';
import { RequestDetailsCommentsComponent } from './Components/request-details-comments/request-details-comments.component';
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";

@NgModule({
  declarations: [
    FiduciaryRequestSearchComponent,
    FiduciarySearchFormComponent,
    FiduciaryRequestsTableComponent,
    RequestDetailsComponent,
    RequestDetailsDocumentsComponent,
    RequestDetailsCommentsComponent
  ],
  imports: [
    CommonModule,
    FiduciarySearchRoutingModule,
    SharedModule,
    FormsModule,
    ReactiveFormsModule,
    FormSharedModule,
    UniButtonsModule,
    UniSelectModule,
    UniFormFieldModule,
    UniStepperModule,
    UniInputModule,
    UniTableModule,
    UniSummaryModule,
    NgxFileDropModule,
    FontAwesomeModule
  ],
})
export class FiduciarySearchModule {}
